'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import LoginComponent from './components/LoginComponent';

// Componente de placeholder que sempre renderiza o mesmo conteúdo
const PlaceholderContent = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
      <h1 className="text-3xl font-bold text-green-600 mb-4">SST Exames</h1>
      <h2 className="text-xl font-semibold text-gray-900 mb-6">Pesquisa Psicossocial</h2>

      <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded-lg mb-6">
        <p className="font-medium">Acesso Restrito</p>
        <p className="text-sm mt-1">
          Para acessar a pesquisa, use um link válido fornecido pela empresa.
        </p>
      </div>

      <p className="text-gray-600 text-sm">
        Se você recebeu um link de pesquisa, clique nele diretamente.
      </p>
    </div>
  </div>
);

export default function Home() {
  const pathname = usePathname();
  const [isMounted, setIsMounted] = useState(false);
  const [uuid, setUuid] = useState<string | null>(null);

  useEffect(() => {
    setIsMounted(true);
    // Verificar se é uma rota de UUID apenas no cliente
    if (typeof window !== 'undefined') {
      const segments = pathname.split('/').filter(Boolean);
      if (segments.length === 1 && segments[0].trim().length > 0) {
        setUuid(segments[0]);
      } else {
        setUuid(null);
      }
    }
  }, [pathname]);

  // Sempre renderizar o mesmo conteúdo inicial para evitar problemas de hidratação
  // Só mudar após montagem no cliente
  if (!isMounted) {
    return <PlaceholderContent />;
  }

  // Se for uma rota de UUID, renderizar componente de login
  if (uuid) {
    return <LoginComponent uuid={uuid} />;
  }

  // Página inicial normal
  return <PlaceholderContent />;
}
